export const ProposalTrackingAgentPermissions = {
  ProposalTrackingAgentPermissions: {
    permissionsId: "af547082-abca-4d76-0087-08dd03ecea2b",
    permissionsName: "Proposal Tracking Agent",
    description: null,
    componentsId: null,
    components: null,
  },
};
